<template> 
  <div class="js-app">
    <router-view/>
  </div>
</template>
<script>

export default {
  data() {
      return {};
  },
  created() {
      var _this = this;
      //_this.$common.enum_config_init();
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
